import { render, staticRenderFns } from "./DashboardDoughnutChart.vue?vue&type=template&id=15e8a3c1&scoped=true&"
import script from "./DashboardDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./DashboardDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDoughnutChart.vue?vue&type=style&index=0&id=15e8a3c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e8a3c1",
  null
  
)

export default component.exports